// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"b143c77b","769":"55ffade6"}[chunkId] + ".chunk.css";
};